/**
 * Remembers the last campaigns-list page across routes so "up" navigation from
 * a campaign (the in-app back button and the "Campaign" breadcrumb crumb) can
 * return to the list at the page the user left — independent of browser history
 * (which we deliberately leave to step through tabs). sessionStorage keeps it
 * per-tab and clears when the tab closes.
 */
const KEY = 'discovr.campaignsListPage';

export function setLastCampaignsListPage(page: number): void {
  try {
    if (page > 1) {
      sessionStorage.setItem(KEY, String(page));
    } else {
      sessionStorage.removeItem(KEY);
    }
  } catch {
    // Private mode / storage disabled — up-nav just falls back to page 1.
  }
}

/** Last list page (>= 1), or undefined when unset — callers omit `?page` then. */
export function getLastCampaignsListPage(): number | undefined {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return undefined;
    const n = Number.parseInt(raw, 10);
    return Number.isInteger(n) && n > 1 ? n : undefined;
  } catch {
    return undefined;
  }
}
